import { render } from "./SystemThemeUploadForm.vue?vue&type=template&id=0d0b0c2e&ts=true"
import script from "./SystemThemeUploadForm.vue?vue&type=script&lang=ts"
export * from "./SystemThemeUploadForm.vue?vue&type=script&lang=ts"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__